import Toast from "shared/toast";

export default function bulkSuccessToast(sourceNumbers, destinationParams) {
  const numberCount = sourceNumbers.length;
  const { name, link } = destinationParams;

  return Toast.success({
    title: "Successfully moved Promo Numbers",
    message: `${numberCount} of the selected Promo Numbers have been moved to ${name}`,
    sticky: true,
    action: {
      text: "View Campaign",
      href: link,
      target: "_blank"
    }
  });
}
